module.exports = __webpack_public_path__ + "static/img/航空航天展厅.5076103d.png";